export class PowerUp {
    constructor(x, y) {
        this.x = x;
        this.y = y;
        this.radius = 12;
        this.collected = false;
        this.lifetime = 600; // 10 seconds

        // Random power-up type
        const types = [
            { id: 'speed',       name: 'Speed Burst',    color: '#00ffff', duration: 5000 },
            { id: 'invincible',  name: 'Shield',         color: '#ffd700', duration: 3000 },
            { id: 'damage',      name: 'Power Burst',    color: '#ff0000', duration: 5000 },
            { id: 'multishot',   name: 'Multi-Shot',     color: '#ff00ff', duration: 4000 },
            { id: 'slowtime',    name: 'Slow Time',      color: '#00ff00', duration: 3000 },
            { id: 'magnet',      name: 'Coin Magnet',    color: '#ffaa00', duration: 6000 },
            { id: 'bomb',        name: 'BOMB',           color: '#00e8ff', duration: 0 },
            { id: 'clone2',      name: 'Clone x2',       color: '#88ffdd', duration: 8000 },
            { id: 'clone3',      name: 'Clone x3',       color: '#44ffaa', duration: 8000 },
            { id: 'freeze',      name: 'Freeze',         color: '#55ccff', duration: 5000 },
            { id: 'supermagnet', name: 'Super Magnet',   color: '#ff88ff', duration: 8000 },
        ];

        this.type = types[Math.floor(Math.random() * types.length)];
        this.pulsePhase = Math.random() * Math.PI * 2;
    }

    update() {
        this.lifetime--;
        this.pulsePhase += 0.1;
        return this.lifetime > 0;
    }

    draw(ctx) {
        // Bomb power-ups use the Geometry Wars capsule look
        if (this.type.id === 'bomb') {
            this._drawGeoBomb(ctx);
            return;
        }

        const pulse = Math.sin(this.pulsePhase) * 3;
        const r = this.radius + pulse;

        ctx.save();

        // Soft bloom
        const bloom = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, r + 16);
        bloom.addColorStop(0, this.type.color);
        bloom.addColorStop(1, 'transparent');
        ctx.globalAlpha = 0.35 + Math.sin(this.pulsePhase) * 0.15;
        ctx.fillStyle = bloom;
        ctx.beginPath();
        ctx.arc(this.x, this.y, r + 16, 0, Math.PI * 2);
        ctx.fill();

        // Orbit ring
        ctx.globalAlpha = 0.7;
        ctx.strokeStyle = this.type.color;
        ctx.lineWidth = 2;
        ctx.shadowBlur = 12;
        ctx.shadowColor = this.type.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, r + 6, this.pulsePhase, this.pulsePhase + Math.PI * 1.2);
        ctx.stroke();

        // Core
        ctx.globalAlpha = 1;
        const core = ctx.createRadialGradient(this.x - 3, this.y - 3, 1, this.x, this.y, r);
        core.addColorStop(0, '#ffffff');
        core.addColorStop(0.4, this.type.color);
        core.addColorStop(1, '#00000055');
        ctx.fillStyle = core;
        ctx.beginPath();
        ctx.arc(this.x, this.y, r, 0, Math.PI * 2);
        ctx.fill();

        // Symbol
        ctx.shadowBlur = 0;
        ctx.fillStyle = '#0a0e27';
        ctx.font = 'bold 14px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const symbols = {
            'speed':       '⚡',
            'invincible':  '🛡️',
            'damage':      '💥',
            'multishot':   '✨',
            'slowtime':    '⏱️',
            'magnet':      '🧲',
            'clone2':      '👥',
            'clone3':      '👾',
            'freeze':      '❄️',
            'supermagnet': '🔮',
        };
        ctx.fillText(symbols[this.type.id] || '★', this.x, this.y);

        ctx.restore();
    }

    _drawGeoBomb(ctx) {
        const pulse = Math.sin(this.pulsePhase) * 0.5 + 0.5;
        const w = 16;
        const h = 48;
        const x = this.x;
        const y = this.y;
        const rr = 6;

        ctx.save();
        const bloom = ctx.createRadialGradient(x, y, 0, x, y, 40 + pulse * 8);
        bloom.addColorStop(0, 'rgba(0,232,255,0.35)');
        bloom.addColorStop(1, 'transparent');
        ctx.fillStyle = bloom;
        ctx.beginPath();
        ctx.arc(x, y, 40 + pulse * 8, 0, Math.PI * 2);
        ctx.fill();

        ctx.shadowBlur = 20 + pulse * 10;
        ctx.shadowColor = '#00e8ff';
        ctx.strokeStyle = '#00e8ff';
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.roundRect(x - w / 2, y - h / 2, w, h, rr);
        ctx.stroke();
        ctx.fillStyle = 'rgba(0,40,60,0.4)';
        ctx.fill();

        ctx.strokeStyle = 'rgba(200,255,255,0.85)';
        ctx.lineWidth = 1.2;
        ctx.shadowBlur = 8;
        ctx.beginPath();
        ctx.roundRect(x - w / 2 + 3, y - h / 2 + 3, w - 6, h - 6, 4);
        ctx.stroke();
        ctx.restore();
    }

    checkCollision(player) {
        const dx = this.x - player.x;
        const dy = this.y - player.y;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < this.radius + player.size) {
            this.collected = true;
            return true;
        }
        return false;
    }
}
